// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep * {
  font-family: "Roboto", sans-serif !important;
}

table {
  border-collapse: separate;
  border-spacing: 0;
}

th.mat-header-cell,
td.mat-cell {
  padding: 0 16px !important;
  white-space: nowrap;
}

tr.mat-row:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

tr.mat-row {
  height: 52px;
}

tr.mat-header-row {
  height: 52px;
  background-color: #fafafa;
}

.deactivated-row td {
  color: #aaa !important;
  background-color: #f5f5f5 !important;
  opacity: 0.7;
}

.deactivated-row:hover td {
  background-color: #eeeeee !important;
}

.selection-bar {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  padding: 0 16px;
  border-radius: 8px;
  margin: 10px 0;
  width: 100%;
  min-height: 48px;
}

.selection-info {
  display: flex;
  align-items: center;
}

.vertical-divider {
  width: 1px;
  height: 24px;
  background-color: #dbdbdb;
  margin: 0 12px;
}

.selection-count {
  font-weight: 500;
  color: #1c1c1c;
  font-size: 14px;
  font-weight: 400;
}

.send-link-btn {
  background-color: transparent !important;
  color: #1288FF !important;
  border: 1px solid #1288FF !important;
  border-radius: 24px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
  cursor: pointer;
}

.send-link-btn:disabled {
  color: #999999 !important;
  border-color: #dbdbdb !important;
  cursor: not-allowed;
}

.white-spinner ::ng-deep circle {
  stroke: #999999 !important;
}

.filter-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.filter-row mat-form-field {
  width: 250px;
}

.btn {
  background: linear-gradient(90deg, #00b2ff 0%, #1288ff 100%) !important;
  color: white !important;
  border-radius: 24px !important;
  font-size: 14px;
  font-weight: 600;
}

.ml-auto {
  margin-left: auto !important;
}

.custom-dialog {
  border-radius: 16px;
}

.filter-row mat-form-field {
  width: 250px;
}

::ng-deep .filter-row .mat-form-field-wrapper {
  padding: 0 !important;
  margin: 0 !important;
}

::ng-deep .filter-row .mat-form-field-subscript-wrapper {
  display: none !important;
}

::ng-deep .filter-row .mat-form-field-infix {
  padding: 8px 0 !important;
  border-top: 0 !important;
  width: auto !important;
}

::ng-deep
  .filter-row
  .mat-form-field-appearance-outline
  .mat-form-field-outline {
  color: #e0e0e0 !important;
}

::ng-deep
  .filter-row
  .mat-form-field-appearance-outline:hover
  .mat-form-field-outline-thick,
::ng-deep
  .filter-row
  .mat-form-field-appearance-outline.mat-focused
  .mat-form-field-outline-thick {
  color: #b0b0b0 !important;
}

.status-label.details-submitted {
  background-color: #fcfee8;
  color: #8f9600;
}

.btn-outline-primary {
  background-color: transparent !important;
  color: #da5330 !important;
  border: 1px solid #da5330 !important;
  border-radius: 24px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
}

h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #1c1c1c;
  font-family: "Roboto", sans-serif !important;
}

:host ::ng-deep .mat-cell {
  color: #616161;
  font-weight: 400;
}

:host ::ng-deep .mat-header-cell {
  color: #1c1c1c;
  font-weight: 600;
  font-size: 12px;
}
:host ::ng-deep .mat-form-field-flex {
  margin-top: 0px !important;
  padding-top: 10px !important;
  height: 40px !important;
}

:host ::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {
  padding: 0 !important;
}

:host ::ng-deep .mat-input-element {
  font-size: 16px !important;
  font-weight: 400;
}

.status-label.details-submitted {
  background-color: #ecf7ed;
  color: #0a9913;
}

.status-label {
  padding: 4px 8px;
  border-radius: 24px;
}

.loader-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  background: rgba(255, 255, 255, 0.9);
  margin: 20px 0;
}

.loading-text {
  margin-top: 24px;
  font-size: 16px;
  font-weight: 500;
  color: #1c1c1c;
  animation: text-pulse 1.8s ease-in-out infinite;
}

.download-container {
  position: relative;
  display: inline-block;
}

.download-btn {
  display: flex;
  align-items: center;
  gap: 4px;
}

.arrow {
  font-size: 18px;
}

.dropdown {
  position: absolute;
  top: 110%;
  right: 0;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  min-width: 160px;
}

.dropdown div {
  padding: 10px 14px;
  cursor: pointer;
}

.dropdown div:hover {
  background: #f5f7fa;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/careplus/employee-data-submitted/employee-data-submitted.component.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uEAAuE;EACvE,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;;;;;EAQE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;AACA,o7RAAo7R","sourcesContent":[":host ::ng-deep * {\n  font-family: \"Roboto\", sans-serif !important;\n}\n\ntable {\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\nth.mat-header-cell,\ntd.mat-cell {\n  padding: 0 16px !important;\n  white-space: nowrap;\n}\n\ntr.mat-row:hover {\n  background-color: #f5f5f5;\n  cursor: pointer;\n}\n\ntr.mat-row {\n  height: 52px;\n}\n\ntr.mat-header-row {\n  height: 52px;\n  background-color: #fafafa;\n}\n\n.deactivated-row td {\n  color: #aaa !important;\n  background-color: #f5f5f5 !important;\n  opacity: 0.7;\n}\n\n.deactivated-row:hover td {\n  background-color: #eeeeee !important;\n}\n\n.selection-bar {\n  display: flex;\n  align-items: center;\n  background-color: #f5f5f5;\n  padding: 0 16px;\n  border-radius: 8px;\n  margin: 10px 0;\n  width: 100%;\n  min-height: 48px;\n}\n\n.selection-info {\n  display: flex;\n  align-items: center;\n}\n\n.vertical-divider {\n  width: 1px;\n  height: 24px;\n  background-color: #dbdbdb;\n  margin: 0 12px;\n}\n\n.selection-count {\n  font-weight: 500;\n  color: #1c1c1c;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.send-link-btn {\n  background-color: transparent !important;\n  color: #1288FF !important;\n  border: 1px solid #1288FF !important;\n  border-radius: 24px !important;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n  cursor: pointer;\n}\n\n.send-link-btn:disabled {\n  color: #999999 !important;\n  border-color: #dbdbdb !important;\n  cursor: not-allowed;\n}\n\n.white-spinner ::ng-deep circle {\n  stroke: #999999 !important;\n}\n\n.filter-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.filter-row mat-form-field {\n  width: 250px;\n}\n\n.btn {\n  background: linear-gradient(90deg, #00b2ff 0%, #1288ff 100%) !important;\n  color: white !important;\n  border-radius: 24px !important;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.ml-auto {\n  margin-left: auto !important;\n}\n\n.custom-dialog {\n  border-radius: 16px;\n}\n\n.filter-row mat-form-field {\n  width: 250px;\n}\n\n::ng-deep .filter-row .mat-form-field-wrapper {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n::ng-deep .filter-row .mat-form-field-subscript-wrapper {\n  display: none !important;\n}\n\n::ng-deep .filter-row .mat-form-field-infix {\n  padding: 8px 0 !important;\n  border-top: 0 !important;\n  width: auto !important;\n}\n\n::ng-deep\n  .filter-row\n  .mat-form-field-appearance-outline\n  .mat-form-field-outline {\n  color: #e0e0e0 !important;\n}\n\n::ng-deep\n  .filter-row\n  .mat-form-field-appearance-outline:hover\n  .mat-form-field-outline-thick,\n::ng-deep\n  .filter-row\n  .mat-form-field-appearance-outline.mat-focused\n  .mat-form-field-outline-thick {\n  color: #b0b0b0 !important;\n}\n\n.status-label.details-submitted {\n  background-color: #fcfee8;\n  color: #8f9600;\n}\n\n.btn-outline-primary {\n  background-color: transparent !important;\n  color: #da5330 !important;\n  border: 1px solid #da5330 !important;\n  border-radius: 24px !important;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n}\n\nh2 {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 600;\n  color: #1c1c1c;\n  font-family: \"Roboto\", sans-serif !important;\n}\n\n:host ::ng-deep .mat-cell {\n  color: #616161;\n  font-weight: 400;\n}\n\n:host ::ng-deep .mat-header-cell {\n  color: #1c1c1c;\n  font-weight: 600;\n  font-size: 12px;\n}\n:host ::ng-deep .mat-form-field-flex {\n  margin-top: 0px !important;\n  padding-top: 10px !important;\n  height: 40px !important;\n}\n\n:host ::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {\n  padding: 0 !important;\n}\n\n:host ::ng-deep .mat-input-element {\n  font-size: 16px !important;\n  font-weight: 400;\n}\n\n.status-label.details-submitted {\n  background-color: #ecf7ed;\n  color: #0a9913;\n}\n\n.status-label {\n  padding: 4px 8px;\n  border-radius: 24px;\n}\n\n.loader-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 80px 0;\n  background: rgba(255, 255, 255, 0.9);\n  margin: 20px 0;\n}\n\n.loading-text {\n  margin-top: 24px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #1c1c1c;\n  animation: text-pulse 1.8s ease-in-out infinite;\n}\n\n.download-container {\n  position: relative;\n  display: inline-block;\n}\n\n.download-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.arrow {\n  font-size: 18px;\n}\n\n.dropdown {\n  position: absolute;\n  top: 110%;\n  right: 0;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n  font-size: 14px;\n  min-width: 160px;\n}\n\n.dropdown div {\n  padding: 10px 14px;\n  cursor: pointer;\n}\n\n.dropdown div:hover {\n  background: #f5f7fa;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
